import styled, { keyframes } from "styled-components";
import theme from "theme";

export const rotate = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

export const dash = keyframes`
    0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
    }
    100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
    }
`;

export const Loader = styled.svg`
    animation: ${rotate} 2s linear infinite;

    & > circle {
        animation: ${dash} 1.5s ease-in-out infinite;
        color: ${theme.colors.purple.primary};
    }
`;

export const Wrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    border-radius: 24px;
`;
